import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { ToastProvider } from './toast';
import { UserProvider } from './user';
import { FlashProvider } from './flash';
import { CompanyProvider } from './company';
import { LayoutProvider } from './layout';
import { WebSocketProvider } from './websocket';

export * from './toast';
export * from './user';
export * from './flash';
export * from './company';
export * from './dashboard';
export * from './layout';
export * from './websocket';

export const MainProvider = ({ children }) => {
  return (
    <LayoutProvider>
      <FlashProvider>
        <WebSocketProvider>
          <UserProvider>
            <ToastProvider>
              <CompanyProvider>
                <DndProvider backend={HTML5Backend}>
                  {children}
                </DndProvider>
              </CompanyProvider>
            </ToastProvider>
          </UserProvider>
        </WebSocketProvider>
      </FlashProvider>
    </LayoutProvider>
  );
};
